const registry = {};

export const isProductFromZodiac = id => id.length === 3;
registry.isProductFromZodiac = isProductFromZodiac;

export const getUrl = () => {
  return "https://www.zodiac-poolcare.fr/reviewsq3/";
};
registry.getUrl = getUrl;

export const getAvis = () => {
  return "https://avis.zodiac-community.com/";
};
registry.getAvis = getAvis;

export const getProductUrl = lang => {
  switch (lang) {
    case "es":
      return "https://www.zodiac-poolcare.es";
    case "it":
      return "https://www.zodiac-poolcare.it";
    case "pt":
      return "https://www.zodiac-poolcare.pt";
    case "de":
      return "https://www.zodiac-poolcare.de";
    case "fr":
    default:
      return "https://www.zodiac-poolcare.fr";
  }
};
registry.getProductUrl = getProductUrl;

export const getLocatorUrl = lang => {
  switch (lang) {
    case "es":
      return "https://www.zodiac-poolcare.es/localizador-tiendas";
    case "pt":
      return "https://www.zodiac-poolcare.pt/localizador-de-lojas";
    case "it":
      return "https://www.zodiac-contatti.it";
    case "de":
      return "https://www.zodiac-poolcare.de/verkaufsstellen";
    case "fr":
    default:
      return "https://www.zodiac-poolcare.fr/localisateur-de-magasin";
  }
};
registry.getLocatorUrl = getLocatorUrl;

export default registry;
